import type { ExcursionPage } from "../slug-excursions";
import menton from "@/assets/images/excursions/destinations/menton.webp";

const page: ExcursionPage = {
  slug: "riviera-italienne",
  hero: {
    title: "Excursion Menton – Riviera Italienne",
    subtitle:
      "Couleurs pastel et dolce vita entre Menton et la frontière italienne.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "Réserver",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Devis",
    image: menton,
  },
  highlights: {
    title: "Points forts",
    items: [
      { text: "Menton : façades pastel, front de mer" },
      { text: "Dolce vita côté italien, spécialités locales" },
      { text: "Jardins, villas et vues mer" },
      { text: "Marchés italiens (selon jour)" },
    ],
  },
  itinerary: {
    title: "Itinéraire type",
    steps: [
      {
        title: "Menton",
        description: "Vieille ville, basilique, front de mer.",
      },
      {
        title: "Vintimille (selon jour)",
        description: "Marché, spécialités italiennes.",
      },
      {
        title: "Bordighera (option)",
        description: "Promenade, villas, cafés.",
      },
      {
        title: "Milan (option journée longue)",
        description:
          "Extension sur demande avec itineraire optimise depuis la Riviera italienne.",
      },
    ],
  },
  practical: {
    title: "Infos pratiques",
    items: [
      { label: "Durée", value: "4 à 7 heures" },
      { label: "Documents", value: "Carte d'identité / passeport" },
      { label: "Départ", value: "Cannes" },
      { label: "Extension", value: "Milan sur demande" },
      { label: "Monnaie", value: "Euro (Italie)" },
    ],
  },
};

export default page;
